// extracted by mini-css-extract-plugin
export default {"navWrapper":"ResumeNav_navWrapper__+XVJ-","navInner":"ResumeNav_navInner__7afFw","navButton":"ResumeNav_navButton__uRbgV","active":"ResumeNav_active__s8Dxz"};